import React from 'react';
import Navbar from '../../Components/Navbar';
import { useTranslation } from 'react-i18next';


const TermsAndPolicies = () => {
  const { t } = useTranslation();
  const currentDate = 'December 1, 2025'; 
  const currentYear = new Date().getFullYear();

  return (
    <div className="bg-[var(--bg-black)] text-[var(--text-black)] min-h-screen py-12 pt-20">
      <div className='absolute left-0 top-0 w-full bg-[var(--bg-black)]'>
        <Navbar minimal />
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-xl bg-[var(--bg-black)] border border-[var(--border)] p-6 sm:p-8 space-y-10 shadow-lg">
          {/* Header */}
          <div className="text-left">
            <h1 className="text-3xl md:text-4xl font-bold text-[var(--text-black)]">
              {t('termsAndPrivacy.header.title')}
            </h1>
            <p className="mt-3 text-[var(--text-black)]">
              {t('termsAndPrivacy.header.lastUpdated', { date: currentDate })}
            </p>
            <p
              className="mt-4 text-[var(--text-secondary)] max-w-2xl"
              dangerouslySetInnerHTML={{
                __html: t('termsAndPrivacy.header.intro', {
                  interpolation: { escapeValue: false } // allows <strong>
                })
              }}
            />
          </div>

          {/* Section 1 */}
          <section>
            <h2 className="text-2xl font-bold text-[var(--text-black)] mb-4">
              {t('termsAndPrivacy.sections.1.title')}
            </h2>
            <p className="text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.1.content')}
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-2xl font-bold text-[var(--text-primary)] mb-4">
              {t('termsAndPrivacy.sections.2.title')}
            </h2>
            <p
              className="text-[var(--text-secondary)]"
              dangerouslySetInnerHTML={{
                __html: t('termsAndPrivacy.sections.2.content', {
                  interpolation: { escapeValue: false }
                })
              }}
            />
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-2xl font-bold text-[var(--text-primary)] mb-4">
              {t('termsAndPrivacy.sections.3.title')}
            </h2>
            <p className="text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.3.intro')}
            </p>
            <ul className="list-disc list-inside mt-2 text-[var(--text-secondary)] space-y-1">
              {t('termsAndPrivacy.sections.3.items', { returnObjects: true }).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p className="mt-3 text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.3.conclusion')}
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-2xl font-bold text-[var(--text-primary)] mb-4">
              {t('termsAndPrivacy.sections.4.title')}
            </h2>
            <p
              className="text-[var(--text-secondary)]"
              dangerouslySetInnerHTML={{
                __html: t('termsAndPrivacy.sections.4.intro', {
                  interpolation: { escapeValue: false }
                })
              }}
            />
            <ul className="list-disc list-inside mt-2 text-[var(--text-secondary)] space-y-1">
              {t('termsAndPrivacy.sections.4.items', { returnObjects: true }).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p className="mt-3 text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.4.conclusion')}
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-2xl font-bold text-[var(--text-primary)] mb-4">
              {t('termsAndPrivacy.sections.5.title')}
            </h2>
            <p className="text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.5.content')}
            </p>
            <p className="mt-2 text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.5.restriction')}
            </p>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-2xl font-bold text-[var(--text-primary)] mb-4">
              {t('termsAndPrivacy.sections.6.title')}
            </h2>
            <p className="text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.6.intro')}
            </p>
            <ul className="list-disc list-inside mt-2 text-[var(--text-secondary)] space-y-1">
              {t('termsAndPrivacy.sections.6.items', { returnObjects: true }).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p className="mt-3 text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.6.conclusion')}
            </p>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-2xl font-bold text-[var(--text-primary)] mb-4">
              {t('termsAndPrivacy.sections.7.title')}
            </h2>
            <p className="text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.7.intro')}
            </p>

            <h3 className="text-xl font-semibold text-[var(--text-primary)] mt-4">
              {t('termsAndPrivacy.sections.7.whatWeCollect.title')}
            </h3>
            <ul className="list-disc list-inside mt-2 text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.7.whatWeCollect.items', { returnObjects: true }).map((item, i) => (
                <li
                  key={i}
                  dangerouslySetInnerHTML={{
                    __html: item
                  }}
                />
              ))}
            </ul>

            <h3 className="text-xl font-semibold text-[var(--text-primary)] mt-4">
              {t('termsAndPrivacy.sections.7.howWeUseIt.title')}
            </h3>
            <ul className="list-disc list-inside mt-2 text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.7.howWeUseIt.items', { returnObjects: true }).map((item, i) => (
                <li
                  key={i}
                  dangerouslySetInnerHTML={{
                    __html: item
                  }}
                />
              ))}
            </ul>

            <h3 className="text-xl font-semibold text-[var(--text-primary)] mt-4">
              {t('termsAndPrivacy.sections.7.yourRights.title')}
            </h3>
            <p className="text-[var(--text-secondary)] mt-2">
              {t('termsAndPrivacy.sections.7.yourRights.intro')}
            </p>
            <ul className="list-disc list-inside mt-2 text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.7.yourRights.items', { returnObjects: true }).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-2xl font-bold text-[var(--text-primary)] mb-4">
              {t('termsAndPrivacy.sections.8.title')}
            </h2>
            <p className="text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.8.policyUpdate')}
            </p>
            <p className="mt-4 text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.8.contactIntro')}
            </p>
            <p className="mt-2">
              <a
                href={`mailto:${t('termsAndPrivacy.sections.8.email')}`}
                className="text-pink-500 hover:underline no-underline"
              >
                {t('termsAndPrivacy.sections.8.email')}
              </a>
            </p>
            <p className="mt-2 text-[var(--text-secondary)]">
              {t('termsAndPrivacy.sections.8.responseTime')}
            </p>
          </section>

          {/* Footer */}
          <div className="pt-6 border-t border-[var(--border)] text-center text-[var(--text-secondary)] text-sm">
            <span
              dangerouslySetInnerHTML={{
                __html: t('termsAndPrivacy.footer', { year: currentYear })
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndPolicies;